import { useQuery } from '@tanstack/react-query'
import {
  getPurseById,
  GetPurseParams,
} from '@/queries/program_purses/requests.ts'
import { PURSE_KEYS } from '@/queries/program_purses/keys.ts'

const useProgramPurseQuery = (request: GetPurseParams) => {
  return useQuery({
    queryKey: PURSE_KEYS.PURSE_DETAILS(request.purseId, request.programId),
    queryFn: () => getPurseById(request),
  })
}

export default useProgramPurseQuery
